import { createContext, useContext } from 'react';

/**
 * Online/last-seen state for chat members. Kept apart from StreamChatContext
 * so presence events (frequent) re-render only the avatars and headers that
 * show presence — not the app shell, which reads the core chat context for
 * the unread badge.
 */
export const ChatPresenceContext = createContext(null);

const OFFLINE = { online: false, lastSeen: null };
const NO_PRESENCE = { userPresence: {}, getUserOnlineStatus: () => OFFLINE };

export const useChatPresence = () => useContext(ChatPresenceContext) || NO_PRESENCE;
